import React from "react";
import { RequestQuoteModal } from "./components/RequestQuoteModal";
import { useRequestQuote } from "./hooks/useRequestQuote";
import { useTranslation } from "react-i18next";

interface RequestQuoteWidgetProps {
  sku: string;
  productTitle: string;
  countryCode: string;
  shop: string;
}

export const RequestQuoteWidget: React.FC<RequestQuoteWidgetProps> = ({ sku, productTitle, shop }) => {
  const { t } = useTranslation();
  const {
    requestQuoteForPart,
    setRequestQuoteForPart,
    close: closeRequestQuote,
    onSend: onSendRequestQuote,
    saving: isSendingRequestQuote,
  } = useRequestQuote();

  const handleOpenModal = () => {
    setRequestQuoteForPart({
      sku,
      name: productTitle,
    });
  };

  return (
    <div className="w-full">
      <button
        className="text-center w-full justify-center bg-black text-white hover:bg-gray-50 hover:text-gray-600 inline-flex items-center rounded-base px-2 py-2 font-medium ring-1 ring-gray-500/10 ring-inset lg:text-base text-sm"
        onClick={handleOpenModal}
      >
        {t("request_quote_product_page_button")}
      </button>

      {requestQuoteForPart && (
        <RequestQuoteModal
          partSku={sku}
          partName={productTitle}
          onClose={closeRequestQuote}
          isSendingRequestQuote={isSendingRequestQuote}
          shop={shop}
          onSend={onSendRequestQuote}
        />
      )}
    </div>
  );
};
